export const en = {
    ticketRemaining: {
        one: '{count} ticket remaining',
        some: '{count} tickets remaining',
        many: '{count} tickets remaining',
        none: '',
    },
    from: '',
};
